/**
 * A2A Authentication Helper
 * Provides authentication token getter function for A2A clients
 */

import { supabaseAdmin } from '../lib/supabase.js';

/**
 * Get current authentication token from Supabase session
 * @returns {Promise<string|null>} Access token or null if not authenticated
 */
export async function getAuthToken() {
  try {
    const { data: { session }, error } = await supabaseAdmin.auth.getSession();
    
    if (error) {
      console.error('[A2A Auth] Error getting session:', error);
      return null;
    }
    
    if (!session || !session.access_token) {
      console.warn('[A2A Auth] No active session found');
      return null;
    }
    
    return session.access_token;
  } catch (error) {
    console.error('[A2A Auth] Unexpected error getting token:', error);
    return null;
  }
}

/**
 * Create an auth token getter function for A2A client
 * @returns {Function} Async function that returns the auth token
 */
export function createAuthTokenGetter() {
  return getAuthToken;
}

